import { render, staticRenderFns } from "./Testing.vue?vue&type=template&id=7a0018e8&scoped=true&"
import script from "./Testing.vue?vue&type=script&lang=js&"
export * from "./Testing.vue?vue&type=script&lang=js&"
import style0 from "./Testing.vue?vue&type=style&index=0&id=7a0018e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0018e8",
  null
  
)

export default component.exports